import React from "react";
import CCPHeader from "../../components/Header/CCPHeader";
import styles from "./HeaderLayout.module.scss";

export default function HeaderLayout() {
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <CCPHeader/>
      </div>
    </div>
  );
}
